    <app-batch-grid-editor [inGroup]="'stasis-admin stasis-qwerty'"></app-batch-grid-editor>
